import { render, staticRenderFns } from "./ReportMaterialsTableMobile.vue?vue&type=template&id=fba26386&scoped=true&"
import script from "./ReportMaterialsTableMobile.vue?vue&type=script&lang=js&"
export * from "./ReportMaterialsTableMobile.vue?vue&type=script&lang=js&"
import style0 from "./ReportMaterialsTableMobile.vue?vue&type=style&index=0&id=fba26386&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba26386",
  null
  
)

export default component.exports
import {QList,QItem,QItemSection,QItemLabel,QBadge,QBtn,QCheckbox} from 'quasar'
component.options.components = Object.assign({QList,QItem,QItemSection,QItemLabel,QBadge,QBtn,QCheckbox}, component.options.components || {})
